export function handleMLChange(index, name, value, setInputs, options) {
  setInputs((prevInputs) => {
    const newML = [...prevInputs.connection_conveyor];
    const parsedValue = value === '' ? null : parseFloat(value);
    newML[index] = {
      ...newML[index],
      [name]: isNaN(parsedValue) ? value : parsedValue,
    };

    if (name === 'direction' && value === 'merge') {
      newML[index] = {
        ...newML[index],
        divert_option: null,
      };
    }

    return {
      ...prevInputs,
      connection_conveyor: newML,
    };
  });
}

export function handleAddML(setInputs, result) {
  setInputs((prevInputs) => {
    const newML = [
      ...(Array.isArray(prevInputs.connection_conveyor)
        ? prevInputs.connection_conveyor
        : []),
      {
        winding: Math.min(
          parseInt(result.nbr_windings, 10) || 1,
          (prevInputs.connection_conveyor?.length || 0) + 1
        ),
        direction: 'merge',
        divert_option: 'No additional option',
        angle: 0,
      },
    ];

    return {
      ...prevInputs,
      connection_conveyor: newML,
    };
  });
}

export function handleRemoveML(index, setInputs) {
  setInputs((prevInputs) => {
    const newML = prevInputs.connection_conveyor.filter((_, i) => i !== index);

    return { ...prevInputs, connection_conveyor: newML };
  });
}

export function countConnections(options, ml, ml_connection) {
  const { divert_field, divert_options } = divertOptions(options);

  const divertOptionNames = {};
  divert_field.forEach((field) => {
    divertOptionNames[field] = divert_options.find(
      (option) => option.field === field
    )?.name;
  });

  const counts = {};
  divert_field.forEach((field) => {
    counts[field] =
      ml.filter((conv) => conv.divert_option === divertOptionNames[field])
        .length * (ml_connection === 'mounting kit(s)' ? 0 : 1);
  });

  counts['nbr_merge_connection_bridge'] =
    (ml_connection === 'connection bridge' ? 1 : 0) *
    ml.filter((conv) => conv.direction === 'merge').length;
  counts['nbr_divert_connection_bridge'] =
    (ml_connection === 'connection bridge' ? 1 : 0) *
    ml.filter((conv) => conv.direction === 'divert').length;

  counts['nbr_ml_mounting_kit'] =
    (ml_connection === 'mounting kit(s)' ? 1 : 0) * ml.length;
  counts['nbr_ml_heavy_duty'] =
    (ml_connection === 'connection bridge' ? 1 : 0) *
    ml.length *
    (options.find((option) => option.field === 'nbr_ml_heavy_duty') ? 1 : 0);
  counts['nbr_ml_compact'] =
    (ml_connection === 'connection bridge' ? 1 : 0) *
    ml.length *
    (options.find((option) => option.field === 'nbr_ml_compact') ? 1 : 0);

  return counts;
}

export function divertOptions(options) {
  const divert_field = [
    'nbr_divert_option_static_arm',
    'nbr_divert_option_linear_arm',
    'nbr_divert_option_swing_arm_electric',
    'nbr_divert_option_swing_arm',
  ];

  const divert_options = options.filter((option) =>
    divert_field.includes(option.field)
  );
  return { divert_field, divert_options };
}
